import React from "react";

function Skills() {
  return (
    <div className="my-5 p-3 rounded-md border border-solid shadow-md hover:border-green-300">
      <h1 className="text-4xl font-bold mb-1">Skills</h1>
      <div className="grid grid-cols-5 gap-4">
        <div className="my-2">
          <h2 className="text-2xl font-semibold">언어</h2>
          <ul>
            <li>Java</li>
            <li>Javascript</li>
            <li>Python</li>
          </ul>
        </div>

        <div className="my-2 col-span-2">
          <h2 className="text-2xl font-semibold">프레임워크 및 라이브러리</h2>
          <ul>
            <li>Spring / SpringBoot</li>
            <li>SpringSecurity</li>
            <li>React</li>
            <li>JPA / Hibernate</li>
          </ul>
        </div>

        <div className="my-2">
          <h2 className="text-2xl font-semibold">데이터베이스</h2>
          <ul>
            <li>MySQL</li>
            <li>MariaDB</li>
            <li>Oracle DB</li>
          </ul>
        </div>

        <div className="my-2">
          <h2 className="text-2xl font-semibold">형상관리</h2>
          <ul>
            <li>Git</li>
            <li>GitHub</li>
            <li>Source Tree</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Skills;
